import type React from 'react';

import { Alert } from '@change/ds-core-ui';

import { Translate, TranslatePlural } from '@change-corgi/core/react/i18n';

import { useFreePromotionFulfillment } from './hooks/useFreePromotionFulfillment';

type Props = {
	onDismiss?: () => void;
};

export const FreePromotionFulfillment: React.FC<Props> = ({ onDismiss }) => {
	const { data, actions } = useFreePromotionFulfillment({ onDismiss });

	return (
		<Alert
			className="h-full w-full [&>div>div]:flex-row"
			variant="info"
			{...(onDismiss && {
				onDismissClick: actions.handleDismiss,
				dismissButtonAriaLabel: 'Close free promotion fulfillment notification',
			})}
			heading={
				<TranslatePlural
					value="corgi.petition.starter_dashboard.notifications.free_promo_fulfillment.title"
					replacements={{ numSignatures: data.signaturesLocalized }}
					count={data.signatures}
				/>
			}
			data-qa="free-promotion-fulfillment-section-message"
		>
			<Translate value="corgi.petition.starter_dashboard.notifications.free_promo_fulfillment.body" />
		</Alert>
	);
};
